<template>
  <div class="p-4">
    <el-button class="float-right" type="primary" icon="el-icon-plus" circle size="small"
               @click="openNewPermissionDialog()"></el-button>
    <el-table
      :data="permissions.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Enabled?">
        <template slot-scope="scope">
          <span v-if="scope.row.status === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="updatePermission(scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deletePermission(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <PermissionUpdateForm />
    <NewPermissionForm />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import PermissionUpdateForm from './_includes/PermissionUpdateForm.vue';
import NewPermissionForm from './_includes/NewPermissionForm.vue';

export default {
  name: 'Permissions',
  components: {
    PermissionUpdateForm,
    NewPermissionForm,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    permissions() {
      return flatMap(this.$store.state.SecurityModule.Permission.permissions);
    },
  },
  methods: {
    openNewPermissionDialog() {
      this.$modal.show('new-permission-modal');
    },
    updatePermission(permission) {
      this.$modal.show('update-permission-modal');
      this.$store.commit('SecurityModule/Permission/setProperty', { property: 'permission', payload: permission });
    },
    deletePermission(permissionId) {
      this.$confirm('Are you sure you want to delete this permission?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SecurityModule/Permission/deletePermission', { permissionId });
          this.$notify.success({
            title: 'Success',
            message: 'Permission has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
